const AGIRACT_FETCH_REQUEST = 'AGIRACT_FETCH_REQUEST'
const AGIRACT_FETCH_SUCCESS = 'AGIRACT_FETCH_SUCCESS'
const AGIRACT_FETCH_FAILURE = 'AGIRACT_FETCH_FAILURE'

const AGIRACT_SUBMIT_REQUEST = 'AGIRACT_SUBMIT_REQUEST'
const AGIRACT_SUBMIT_SUCCESS = 'AGIRACT_SUBMIT_SUCCESS'
const AGIRACT_SUBMIT_FAILURE = 'AGIRACT_SUBMIT_FAILURE'

const AGIRACT_CAUSAS_REQUEST = 'AGIRACT_CAUSAS_REQUEST'
const AGIRACT_CAUSAS_SUCCESS = 'AGIRACT_CAUSAS_SUCCESS'
const AGIRACT_CAUSAS_FAILURE = 'AGIRACT_CAUSAS_FAILURE'

const AGIRACT_CLEAR = 'AGIRACT_CLEAR'

const initialState = {
  loading: false,
  submitting: false,
  loadingCausas: false,
  data: null,
  causasFalha: [],
  error: null
}

export default function agiractReducer(state = initialState, action) {
  switch (action.type) {
    case AGIRACT_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case AGIRACT_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      }

    case AGIRACT_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case AGIRACT_SUBMIT_REQUEST:
      return {
        ...state,
        submitting: true,
        error: null
      }

    case AGIRACT_SUBMIT_SUCCESS:
      return {
        ...state,
        submitting: false,
        error: null
      }

    case AGIRACT_SUBMIT_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload
      }

    case AGIRACT_CAUSAS_REQUEST:
      return {
        ...state,
        loadingCausas: true,
        error: null
      }

    case AGIRACT_CAUSAS_SUCCESS:
      return {
        ...state,
        loadingCausas: false,
        causasFalha: action.payload,
        error: null
      }

    case AGIRACT_CAUSAS_FAILURE:
      return {
        ...state,
        loadingCausas: false,
        error: action.payload
      }

    case AGIRACT_CLEAR:
      return initialState

    default:
      return state
  }
}

export {
  AGIRACT_FETCH_REQUEST,
  AGIRACT_FETCH_SUCCESS,
  AGIRACT_FETCH_FAILURE,
  AGIRACT_SUBMIT_REQUEST,
  AGIRACT_SUBMIT_SUCCESS,
  AGIRACT_SUBMIT_FAILURE,
  AGIRACT_CAUSAS_REQUEST,
  AGIRACT_CAUSAS_SUCCESS,
  AGIRACT_CAUSAS_FAILURE,
  AGIRACT_CLEAR
}